import React from 'react';
import GoogleLogin from 'react-google-login';
import googleIcon from "../../../src/components/assets/images/google.svg"
const DirectGoogleLogin = ({ onSuccess, onFailure }) => {
  // This handler receives the full response from the library
  // and passes only the necessary data up to the parent.
  const handleSuccess = (response) => {
    if (response.profileObj && response.profileObj.email) {
      // response = {...response,profileObj:{...response.profileObj,email:"ana@omegamasonry.com"}}
      onSuccess(response); // Pass the whole response object up
    } else {
      onFailure({ error: 'Could not retrieve profile from Google.' });
    }
  };

  return (
    <GoogleLogin
      clientId='414852214154-ir07ak63fa5bt91rl4ue9lhh5jbqduds.apps.googleusercontent.com'
      onSuccess={handleSuccess}
      onFailure={onFailure}
      cookiePolicy={'single_host_origin'}
      render={(renderProps) => (
        <button
          onClick={renderProps.onClick}
          disabled={renderProps.disabled}
          style={{
            height: 60,
            width: 300,
            fontSize: 15,
            color: '#454f63',
            backgroundColor: '#f7f7fa',
            borderRadius: 12,
            border: 'none',
            outline: 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontFamily: 'SF Pro Display Medium',
          }}
        >
          <img src={googleIcon} alt='' style={{ marginRight: '15px' }} />
          <span>Sign in with Google</span>
        </button>
      )}
    />
  );
};

export default DirectGoogleLogin;
